import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { isValidHttpUrl } from '../utils';
// Extend Window interface to include beacon property
var useBeaconScript = function useBeaconScript() {
    useEffect(function () {
        var beaconUrl = process.env.REACT_APP_BEACON_ANALYTICS_URL;
        if (!beaconUrl || !isValidHttpUrl(beaconUrl)) {
            console.warn('Analytics tool is not configured.');
            return;
        }
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'beaconScript';
        script.async = true;
        script.src = "".concat(beaconUrl, "/beacon.js");
        script.setAttribute('data-log', 'false');
        script.setAttribute('data-api-root', beaconUrl);
        script.setAttribute('data-trackers', 'page,click,form');
        script.setAttribute('data-identity', 'userAndSession');
        document.head.appendChild(script);
        return function () {
            document.head.removeChild(script);
        };
    }, []);
    useEffect(function () {
        if (typeof window !== 'undefined' && window.beacon) {
            var _userObject$userAttri;
            var userObject = JSON.parse(Cookies.get('user') || '{}');
            var nameParts = (_userObject$userAttri = userObject.userAttributes) === null || _userObject$userAttri === void 0 || (_userObject$userAttri = _userObject$userAttri.name) === null || _userObject$userAttri === void 0 ? void 0 : _userObject$userAttri.split(/, | /);
            window.beacon.identify((userObject === null || userObject === void 0 ? void 0 : userObject.username) || '', {
                first_name: (nameParts === null || nameParts === void 0 ? void 0 : nameParts[1]) || '',
                last_name: (nameParts === null || nameParts === void 0 ? void 0 : nameParts[0]) || '',
                email: userObject.username || ''
            });
        }
    }, [window.beacon]);
};
export default useBeaconScript;
